import { createRouter, createWebHistory } from "vue-router";

import Top from "./views/Top.vue";
import Select from "./views/Select.vue";
import Trim from "./views/Trim.vue";
import Edit from "./views/Edit.vue";
import Write from "./views/Write.vue";
import Post from "./views/Post.vue";
import Result from "./views/Result.vue";

export const routerHistory = createWebHistory();

export const route = createRouter({
  history: routerHistory,
  routes: [
    {
      path: "/",
      name: "top",
      component: Top,
    },
    {
      path: "/select",
      name: "select",
      component: Select,
    },
    {
      path: "/trim",
      name: "trim",
      component: Trim,
    },
    {
      path: "/edit",
      name: "edit",
      component: Edit,
    },
    {
      path: "/write",
      name: "write",
      component: Write,
    },
    {
      path: "/post",
      name: "post",
      component: Post,
    },
    {
      path: "/result/:id",
      name: "result",
      component: Result,
      props: true,
    },
  ],
});
